import Axios from "api/Axios";

export const logFailedMessage = async (payload) => {
	try {
		const response = await Axios.post("/log_failed_question/", payload);
		return response.data;
	} catch (error) {
		// throw error;
		console.log("Logging Error:", error);
	}
};
